import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Instagram, Facebook } from 'lucide-react';

// Brand logo URL (transparent background)
const BRAND_LOGO = "https://customer-assets.emergentagent.com/job_17ae6403-2082-451f-978f-8e823488d32d/artifacts/bd5nly0b_tastes%20good%20does%20good%20%20group%20logo%20%20%287%29.png";

// TikTok icon component
const TikTok = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-paper border-t border-primary/20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img 
                src={BRAND_LOGO} 
                alt="Cakery Wonderland" 
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-text-secondary text-sm mb-4">
              The UK's First Purpose Driven Cakery. Creating food experiences that taste good and do good.
            </p>
            <div className="flex items-center gap-2 text-sm text-primary">
              <Heart className="w-4 h-4 fill-primary" />
              <span>15% to charity</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-heading font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/experiences" className="text-text-secondary hover:text-primary transition-colors text-sm">
                  Book Experiences
                </Link>
              </li>
              <li>
                <Link to="/catering" className="text-text-secondary hover:text-primary transition-colors text-sm">
                  Book Catering
                </Link>
              </li>
              <li>
                <Link to="/subscriptions" className="text-text-secondary hover:text-primary transition-colors text-sm">
                  Subscriptions
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-text-secondary hover:text-primary transition-colors text-sm">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-text-secondary hover:text-primary transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="text-white font-heading font-semibold mb-4">Customer Service</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/contact" className="text-text-secondary hover:text-primary transition-colors text-sm">
                  Help & FAQs
                </Link>
              </li>
              <li>
                <a href="#" className="text-text-secondary hover:text-primary transition-colors text-sm">
                  Delivery Information
                </a>
              </li>
              <li>
                <a href="#" className="text-text-secondary hover:text-primary transition-colors text-sm">
                  Terms & Conditions
                </a>
              </li>
              <li>
                <a href="#" className="text-text-secondary hover:text-primary transition-colors text-sm">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="text-white font-heading font-semibold mb-4">Connect With Us</h3>
            <div className="flex gap-3 mb-4">
              <a 
                href="https://www.instagram.com/cakerywonderlandldn" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 bg-primary/10 rounded-lg hover:bg-primary/20 transition-colors"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5 text-primary" />
              </a>
              <a 
                href="https://www.facebook.com/cakerywonderland" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 bg-primary/10 rounded-lg hover:bg-primary/20 transition-colors"
                data-testid="social-facebook"
              >
                <Facebook className="w-5 h-5 text-primary" />
              </a>
              <a 
                href="https://www.tiktok.com/@cakerywonderland" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 bg-primary/10 rounded-lg hover:bg-primary/20 transition-colors"
                data-testid="social-tiktok"
              >
                <TikTok className="w-5 h-5 text-primary" />
              </a>
            </div>
            <p className="text-text-secondary text-sm mb-2">
              Follow us for updates
            </p>
            <p className="text-text-muted text-xs">
              New experiences, behind the scenes & special offers
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-text-muted text-sm">
            © {currentYear} Cakery Wonderland. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-sm text-text-muted">
            <span>Made with</span>
            <Heart className="w-4 h-4 text-primary fill-primary" />
            <span>in London</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
